module.exports = __webpack_public_path__ + "static/media/percentage-active.93e628f9.svg";